import { SANCTION_REASON_LABEL, type SanctionItem } from '@/types';
import type { BonusWeek, CollectorSummary, GroupBonusWeek } from '../types';
import { formatPeriod } from '../utils/payment-formatters';

export type RowVariant = 'default' | 'penalty';
export type Row = {
  concept: string;
  period: string;
  amount: number;
  variant?: RowVariant;
};

function rankingRow(w: BonusWeek): Row {
  return {
    concept: `Ranking #${w.position ?? '—'}`,
    period: formatPeriod(w.weekStart, w.weekStart),
    amount: w.bonus,
  };
}

function groupRow(w: GroupBonusWeek): Row {
  return {
    concept: 'Bonus de equipo',
    period: formatPeriod(w.weekStart, w.weekStart),
    amount: w.amount,
  };
}

function sanctionRow(s: SanctionItem): Row {
  const day = String(s.created_at).slice(0, 10);
  return {
    concept: `Sanción: ${SANCTION_REASON_LABEL[s.reason] ?? s.reason}`,
    period: formatPeriod(day, day),
    amount: -s.eur,
    variant: 'penalty',
  };
}

function pushBonusRows(rows: Row[], summary: CollectorSummary): void {
  summary.bonus?.weeks?.forEach((w) => {
    if (w.bonus > 0) rows.push(rankingRow(w));
  });
  summary.group_bonus?.weeks?.forEach((w) => {
    if (w.amount > 0) rows.push(groupRow(w));
  });
}

function raceRow(summary: CollectorSummary, period: string): Row | null {
  const total = summary.race_bonus?.total ?? 0;
  if (total <= 0) return null;
  return { concept: 'Bonus velocidad', period, amount: total };
}

export function buildRows(summary: CollectorSummary, base: number): Row[] {
  const rows: Row[] = [];
  const period = formatPeriod(summary.period_start, summary.period_end);
  if (base > 0 || summary.total_leads > 0) {
    rows.push({ concept: 'Creadores', period, amount: base });
  }
  pushBonusRows(rows, summary);
  const race = raceRow(summary, period);
  if (race) rows.push(race);
  summary.sanctions?.items?.forEach((s) => rows.push(sanctionRow(s)));
  return rows;
}
